export default __webpack_public_path__ + "775cd130a788bf17394613e7d53edb09.png";